import type { WeddingSettings } from '@shared/settings'
import { Seccion, tieneTexto } from './comunes'

/* ===========================================================================
   Preguntas frecuentes.

   <details>/<summary> nativos: se abren y se leen con teclado y con lector de
   pantalla aunque el JavaScript no llegue a cargar.
   =========================================================================== */

type Pregunta = WeddingSettings['faq'][number]

function completa(item: Pregunta): boolean {
  return tieneTexto(item.question) && tieneTexto(item.answer)
}

export function hayPreguntas(faq: WeddingSettings['faq']): boolean {
  return faq.some(completa)
}

export default function Preguntas({ faq }: { faq: WeddingSettings['faq'] }) {
  const items = faq.filter(completa)

  return (
    <Seccion id="preguntas" eyebrow="Preguntas frecuentes" titulo="Lo que suelen preguntarnos">
      <div className="flex flex-col">
        {items.map((item, i) => (
          <details
            key={item.id}
            className={i === 0 ? 'group py-3' : 'group border-t border-palo/70 py-3'}
          >
            <summary className="flex min-h-[44px] cursor-pointer list-none items-center justify-between gap-4 text-left font-medium text-tinta [&::-webkit-details-marker]:hidden">
              {item.question}
              <span
                aria-hidden="true"
                className="shrink-0 font-mono text-lg leading-none text-palo-hondo transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="mt-3 whitespace-pre-line leading-relaxed text-tinta/85">
              {item.answer}
            </p>
          </details>
        ))}
      </div>
    </Seccion>
  )
}
